
// escala de frío a caliente
const SCALE_ANCHORS = ['#2f6fb9', '#4f9e6a', '#d6c531', '#b94f4f'] // azul, verde, amarillo, rojo

const hexToRgb = hex => {
  const n = parseInt(hex.slice(1), 16)
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255]
}

const rgbToHex = rgb =>
  '#' + rgb.map(v => Math.round(v).toString(16).padStart(2, '0')).join('')

const buildGradientColors = (anchors, colorCount) => {
  //si la cuenta es 0 entonces vacio
  if (colorCount <= 0) return []
  //si la cuenta es 1 entonces solo el primer anchor
  if (colorCount === 1) return [anchors[0]]
  const rgb = anchors.map(hexToRgb)
  const segments = anchors.length - 1
  return Array.from({ length: colorCount }, (_, index) => {
    // imaginando un colorCount de 5, 4 de anchors e index=2 seria:
    /*
      - segments = 3
      - position = (2 / (5 - 1)) * 3 = 1.5
      - lowerAnchor = 1
      - upperAnchor = 2
      - blend = 0.5
    */
    const position = (index / (colorCount - 1)) * segments     // posición global sobre la escala
    const lowerAnchor = Math.floor(position)   //El ancla o escalon inferior 
    const upperAnchor = Math.min(lowerAnchor + 1, segments) //El ancla o escalon superior
    const blend = position - lowerAnchor  // cuando se avanza entre anchors(0.7 por ejemplo)
    //interpolacion lineal, permite calcular un color intermedio entre dos colores, en base a un factor (blend)
    //la formula es: color= colorInferior + (colorSuperior - colorInferior) * blend, lo hacemos para cada canal de color, despues lo convertimos a hex para mostrar
    const result = rgbToHex([0, 1, 2].map(channel => rgb[lowerAnchor][channel] + (rgb[upperAnchor][channel] - rgb[lowerAnchor][channel]) * blend))
    return result
  })
}

export const buildThresholdLines = (thresholds = []) => {
  // Ordena los thresholds por el valor y genera un color para cada uno
  const ordered = [...thresholds].sort((a, b) => a.value - b.value)
  const colors = buildGradientColors(SCALE_ANCHORS, ordered.length)
  return ordered.map(({ label, value }, i) => ({
    value,
    label,
    color: colors[i],
  }))
}